import { Injectable } from '@angular/core';
import { NotificationRepository } from 'src/core/notifications/domain/notification-repository';
import { NotificationsService } from 'src/core/notifications/domain/notifications.service';

@Injectable({
  providedIn: 'any',
})
export class GetUnreadNotificationsCount {
  constructor(
    private readonly notificationRepository: NotificationRepository,
    private readonly notificationsService: NotificationsService
  ) {}

  async execute(): Promise<number> {
    const hadPendingReads = this.notificationsService.hasPendingReads();
    const count = await this.notificationRepository.unreadCount();
    // The server still counts pending reads. Keep the local badge until the queue acknowledges them.
    if (hadPendingReads || this.notificationsService.hasPendingReads()) {
      return this.notificationsService.getUnreadCount();
    }
    await this.notificationsService.setUnreadCount(count);
    return count;
  }
}
